import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { noWhitespaceValidator } from '@shared/validators/no-white-spaces.validator';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'checklist-input',
	templateUrl: './checklist-input.component.html',
	styleUrls: ['./checklist-input.component.scss'],
	imports: [ReactiveFormsModule, NgxTolgeeModule],
})
export class ChecklistInputComponent implements OnInit {
	// TODO add typings later
	@Output() itemSubmitted = new EventEmitter<any>();

	formControl = new FormControl<string>('', [
		Validators.required,
		noWhitespaceValidator(),
	]);

	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}

	submitNewItem() {
		if (this.formControl.valid) {
			this.itemSubmitted.emit({
				text: this.formControl.value,
				checked: false,
			});
			this.formControl.reset();
		}
	}
}
